import SalesManagersService from "../../../../services/salesManagersDataService";

export default {
  data() {
    return {
      salesManagers: [],
    }
  },
  methods: {
    getActiveSalesManagers() {
      return SalesManagersService.getActiveSalesManagers()
        .then(managers => {
          managers.forEach(manager => {
            this.salesManagers.push({
              id: manager.id,
              name: manager.name,
              selectable: true,
            })
          })
        })
    },
  }
}



// WEBPACK FOOTER //
// ./resources/js/views/front/mixins/SalesManager/salesManagerFormMixin.js